import { createContext, useContext } from 'react';

export const ClientProjectsContext = createContext();

export const useClientProjectsContext = () => useContext(ClientProjectsContext);

export default ClientProjectsContext;
